import { render } from "./PatientDatatableNotificationActions.vue?vue&type=template&id=2e8b3304"
import script from "./PatientDatatableNotificationActions.vue?vue&type=script&lang=js"
export * from "./PatientDatatableNotificationActions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__